@if (
    controlPath
        ? ((control && control.invalid && control.touched) || showError) && errorMessages && errorMessages.length
        : showError && errorMessages && errorMessages.length
) {
    <div class="invalidFeedback" (click)="dismissMessage()">
        @for (error of errorMessages; track error) {
            <p>{{ error.errorKey | translate: error.interpolationParams }}</p>
        }
    </div>
}
